import { render, staticRenderFns } from "./CompanyBehindForm.vue?vue&type=template&id=27d7d310&"
import script from "./CompanyBehindForm.vue?vue&type=script&lang=js&"
export * from "./CompanyBehindForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports